<h2>
	{{ "sessions.title" | translate }} - {{ status | titlecase }}
</h2>
<div class="sdp-section-header-description">
	{{ "sessions.info.block.1" | translate }}
	<div class="sdp-refresh-from-header">
		<button
			mat-icon-button
			(click)="refresh()"
			color="primary"
			class="sdp-icon-button"
			matTooltip="{{ 'session.refresh.tooltip' | translate }}"
		>
			<sdp-icon [icon]="refreshIcon"></sdp-icon>
		</button>
	</div>
</div>
<mat-card class="sdp-generic-grid sdp-sessions">
	<div *ngIf="!errorMessage">
		<div>
			<sdp-generic-table
				[columnSchema]="columnSchema"
				[tableName]="'Sessions'"
				[tableData]="sessionsData"
				[rows]="20"
				(onStateChange)="doStateChange($event)"
			></sdp-generic-table>
		</div>
	</div>
	<div *ngIf="!!errorMessage">
		{{ errorMessage }}
		<a href="mailto:{{ supportEmail }}">{{ supportEmail }}</a>
		<div class="sdp-session-error-retry-button">
			<button
				color="accent"
				(click)="refresh()"
				mat-raised-button
			>{{ "error.retry.message" | translate }}</button>
		</div>
	</div>
</mat-card>